import { watch, type App, type WritableComputedRef } from 'vue'
import { buildCookieBannerConfig } from '@/silktide/configs/cookieBanner.config'
import { getI18n } from '@/plugins/i18n'

const CONSENT_VERSION = 'V1.0.0 Mar-2026'
const VERSION_ELEMENT_ID = 'silktide-consent-version'
const FONT_STYLE_ID = 'silktide-custom-font'

function injectFontStyle() {
  if (document.getElementById(FONT_STYLE_ID)) return

  const style = document.createElement('style')
  style.id = FONT_STYLE_ID
  style.textContent = `
    #silktide-banner, #silktide-modal {
      font-family: 'Lotuss Smart HL', system-ui, sans-serif !important;
    }
    #silktide-banner *, #silktide-modal * {
      font-family: inherit !important;
    }
  `
  document.head.appendChild(style)
}

function injectConsentVersion() {
  const footer = document.querySelector('#silktide-modal footer')
  if (!footer || document.getElementById(VERSION_ELEMENT_ID)) return

  const versionEl = document.createElement('span')
  versionEl.id = VERSION_ELEMENT_ID
  versionEl.textContent = CONSENT_VERSION
  versionEl.style.cssText =
    'margin-left: auto; color: var(--primaryColor); font-size: 14px; white-space: nowrap;'
  footer.appendChild(versionEl)
}

function setupObserver() {
  const observer = new MutationObserver(() => {
    injectConsentVersion()
  })
  observer.observe(document.body, { childList: true, subtree: true })
}

function applyConfigAndInject() {
  const config = buildCookieBannerConfig()
  window.silktideCookieBannerManager?.updateCookieBannerConfig(config)

  injectFontStyle()
  // Re-inject after a short delay to let Silktide rebuild the DOM
  setTimeout(() => injectConsentVersion(), 100)
}

export default {
  install(app: App) {
    if (window.silktideCookieBannerManager) {
      applyConfigAndInject()
      setupObserver()
    } else {
      const interval = setInterval(() => {
        if (window.silktideCookieBannerManager) {
          clearInterval(interval)
          applyConfigAndInject()
          setupObserver()
        }
      }, 50)
      setTimeout(() => clearInterval(interval), 10000)
    }

    const locale = getI18n().global.locale as WritableComputedRef<string>
    watch(locale, () => {
      applyConfigAndInject()
    })
  },
}
